import { routes } from '@/shared/routes';

export const refreshFailedClientImportAlert = async () => {
  const alert = document.getElementById('failedClientImportAlert');

  if (!alert) {
    return;
  }

  const response = await fetch(routes.organisations.failedImportCount(), {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    return;
  }

  const { count } = (await response.json()) as { count: number };
  const text = alert.querySelector('[data-failed-import-text]');

  if (text) {
    text.textContent =
      count === 1
        ? '1 organisation failed to import and needs attention.'
        : `${count} organisations failed to import and need attention.`;
  }

  alert.classList.toggle('d-none', count === 0);
};
